import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

// import tailwind
import '@/assets/tailwind.css';

// import bootstrap icons
import 'bootstrap-icons/font/bootstrap-icons.css';

const app = createApp(App);
app.use(store);
app.use(router);
app.mount('#app');
